/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.91.2-v202602022207-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as models from './models';

/**
 * Information about a mentioned user or user group for notification purposes
 */
export interface MentionInputV1 {
    /**
     * The email address of the mentioned user (required for User type, not used for UserGroup)
     */
    "email"?: string;
    /**
     * The display name of the mentioned user or user group
     */
    "name": string;
    /**
     * The source/context where the mention occurred (e.g., 'Vantage comment', 'note')
     */
    "source"?: string;
    /**
     * The type of the mentioned entity
     */
    "type": TypeEnum;
    /**
     * The URL to link to in the notification email
     */
    "url": string;
    /**
     * The UUID of the mentioned user or user group
     */
    "uuid": string;
}

export enum TypeEnum {
    User = 'User' as any,
    UserGroup = 'UserGroup' as any
}
